import { all, call, put, takeEvery } from "redux-saga/effects";

import {
  handleVoteFailed,
  handleVoteStart,
  handleVoteSuccess,
} from "../redux/handleVote";

import { handleVoteApi } from "core/http/service/internalEvents";

import { PayloadAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

function* handleVoteWork(
  action: PayloadAction<{ id: string; postId: string; callback: () => void }>
) {
  const { postId } = action.payload;
  try {
    yield call(handleVoteApi, { postId });

    yield put({
      type: handleVoteSuccess.type,
    });
    toast.success("Bình chọn của bạn đã được gửi thành công");
    action.payload.callback();
  } catch (error: any) {
    yield put({
      type: handleVoteFailed.type,
    });
    toast.error(
      error?.response?.data?.message ||
        error.message ||
        "Có lỗi xảy ra, vui lòng thử lại sau"
    );
  }
}

function* watchHandleVote() {
  yield takeEvery(handleVoteStart.type, handleVoteWork);
}

export default function* handleVoteSaga() {
  yield all([watchHandleVote()]);
}
